export default __webpack_public_path__ + "static/media/BASE_TECNOLOGIA_160__2V_BANNER_01.9a52c545.jpg";